import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ICurrency } from '../../../../shared/models/currency.model';
import { PaymentUtilService } from '../../services';
import { UtilService, VariablesService, VwoService } from '../../../../shared/services';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';
import { environment } from '../../../../../environments/environment';
import {
  DonationConfirmationComponent
} from '../../../donation-confirmation/components/donation-confirmation/donation-confirmation.component';

@Component({
  selector: 'app-payment-header-stories',
  templateUrl: './payment-header-stories.component.html',
  styleUrls: ['./payment-header-stories.component.scss']
})
export class PaymentHeaderStoriesComponent implements OnInit {
  @Input() public fundraiser: IFundraiser;
  @Input() isReward;
  @Input() selectedCurrency;
  @Input() screenName;
  @Input() showBeneficiary;
  @Input() contributeDetails;
  @Input() isStandAlone;
  @Output() userSelectionCurrency: EventEmitter<ICurrency> = new EventEmitter();
  supportedCurrencies: ICurrency[];
  currency;
  params;
  currentUrl;
  domainUrl;
  isMobile;
  constructor(
    private paymentUtilService: PaymentUtilService,
    public utilService: UtilService,
    public location: Location,
    private actRoute: ActivatedRoute,
    public dialog: MatDialog,
    public router: Router,
    public variablesService: VariablesService,
    private vwoService: VwoService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService?.isMobile();
    this.getCurrencyDetails();
    this.actRoute.queryParams.subscribe((params) => {
      this.params = params;
    });

    this.domainUrl = environment.APP.DOMAIN_URL;
  }
  /**Get the details of the currency */
  getCurrencyDetails() {
    this.paymentUtilService.supportedCurrencies.subscribe({
      next: (res) => {
        if (res) {
          setTimeout(() => {
            this.supportedCurrencies = res;
          }, 0);
        }
      }
    });
    this.paymentUtilService.paymentCurrency.subscribe({ next: (res) => this.currency = res });
  }
  /**Get the title */
  getTitle(param, op) {
    if (op) {
      switch (op) {
        case 'c':
          return this.utilService.isMobile() ? '' : 'Enter your card details';
        case 'p':
          return 'Payment using PayTM';
      }
    } else {
      switch (param) {
        case 'rd':
          return 'Choose Reward amount';
        case 'form':
          return 'Choose a contribution amount';
        case 'options':
          return 'Choose payment option';
      }
    }
  }
  /**Get emited currency fromheader and set it */
  setCurrency(currency: ICurrency) {
    this.paymentUtilService.paymentCurrency.next(currency.currency);
    this.userSelectionCurrency.emit(currency);
  }
  /**Back action of payment header */
  back() {
    if (this.screenName === this.params.payment) {
      if (!this.utilService.isMobile()) {
        const dialogRef = this.dialog.open(DonationConfirmationComponent, {
          data: { contributeDetails: this.contributeDetails, currency: this.currency },
          width: '428px',
          panelClass: 'confirmation-modal'
        });
        dialogRef.componentInstance.cancelPayment.subscribe(() => {
          if (this.isStandAlone) {
            this.location.back();
          }
        });
      } else {
        this.dialog.closeAll();
        if (this.isStandAlone) {
          this.location.back();
        }
      }
    } else {
      this.location.back();
      this.paymentUtilService.backButton.next(this.params);
      this.paymentUtilService.cartSubs.forEach(s => s.unsubscribe());
    }
  }

}
